import { render } from "./StaffInformation.vue?vue&type=template&id=36136ecc"
import script from "./StaffInformation.vue?vue&type=script&lang=js"
export * from "./StaffInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__